<template>
<v-dialog class="big" v-model="showFlag" scrollable>
  <v-card>
    <v-card-text>
      <div v-if="isMobile">
        <template v-for="(img, idx) in guiasMobile">
          <img ref="guias" :src="`/images/${img}`" :key="`guia-${idx}`" v-show="currentImgPositionMobile === idx" />
        </template>
      </div>
      <div v-if="!isMobile">
        <template v-for="(img, idx) in guias">
          <img ref="guias" :src="`/images/${img}`" :key="`guia-${idx}`" v-show="currentImgPosition === idx" />
        </template>
      </div>
    </v-card-text>
    <v-card-actions>
      <div class="help-navigation" v-if="!isMobile">
        <md-button @click="goToBack" :disabled="firstImg" :class="{ active: lastImg }">
          <i class="material-icons icon-size-2x">arrow_back</i>
        </md-button>
        <md-button @click="goToNext" :disabled="lastImg" :class="{ active: firstImg }">
          <i class="material-icons icon-size-2x">arrow_forward</i>
        </md-button>
        <md-button @click="close()" class="md-primary cerrar">Cerrar</md-button>
      </div>
      <div class="help-navigation" v-if="isMobile">
        <md-button @click="goToBackMobile" :disabled="firstImgMobile" :class="{ active: lastImgMobile }">
          <i class="material-icons icon-size-2x">arrow_back</i>
        </md-button>
        <md-button @click="goToNextMobile" :disabled="lastImgMobile" :class="{ active: firstImgMobile }">
          <i class="material-icons icon-size-2x">arrow_forward</i>
        </md-button>
        <md-button @click="close()" class="md-primary cerrar">Cerrar</md-button>
      </div>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>
<script>

import resize from '@/mixins/resize.js'

const guias = [ 'guia1.png', 'guia2.png', 'guia3.png' ]
const guiasMobile = [ 'guiar1.jpg', 'guiar2.jpg', 'guiar3.jpg', 'guiar4.jpg', 'guiar5.jpg', 'guiar6.jpg' ]

export default {
  mixins: [resize],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      guias,
      guiasMobile,
      amountOfGuias: guias.length,
      amountOfGuiasMobile: guiasMobile.length,
      currentImgPosition: 0,
      currentImgPositionMobile: 0,
      showFlag: false
    }
  },
  methods: {
    close () {
      this.showFlag = false
    },
    goToBack () {
      this.currentImgPosition--
    },
    goToNext () {
      this.currentImgPosition++
    },
    goToBackMobile () {
      this.currentImgPositionMobile--
    },
    goToNextMobile () {
      this.currentImgPositionMobile++
    }
  },
  computed: {
    firstImg () {
      return this.currentImgPosition === 0
    },
    lastImg () {
      return this.currentImgPosition === this.amountOfGuias - 1
    },
    firstImgMobile () {
      return this.currentImgPositionMobile === 0
    },
    lastImgMobile () {
      return this.currentImgPositionMobile === this.amountOfGuiasMobile - 1
    }
  },
  watch: {
    showFlag (val) {
      if (!val) this.$emit('onCloseEvent')
    },
    showDialog () {
      this.showFlag = this.showDialog
    }
  }
}
</script>
<style lang="stylus" scoped>
.active {
  border-top: 1px solid blue
}
.v-dialog-actions {
  justify-content: inherit
}
.md-button.md-primary.cerrar {
  position: absolute;
  right: 10px;
}
.v-dialog.big {
  width: 95%
  max-height: 95%
}

</style>
